/* global BaseUrl, EpgEnabled */
// eslint-disable-line no-unused-vars

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { animateScroll, Element } from 'react-scroll';
import { StickyContainer } from 'react-sticky';
import classNames from 'classnames';
import { getCookie } from 'helpers/Storage';
import { setHelmetTags } from 'helpers/HelmetHelper';
import {
  isFNCv2Enabled,
  nationDigitalChannelEnabled,
  strikeBannerEnabled,
} from 'helpers/ConfigHelper';
import _ from 'lodash';
import BreadcrumbsComponent, { breadcrumbsLiveParser } from 'components/Breadcrumbs';
import Loader from 'components/Loader';
import StrikeBanner, { STRIKE_PAGE_TYPE_SCHEDULE } from 'components/StrikeBanner';
import Schema from 'componentsV2/Schema';
import { SCHEMA_TYPES } from 'componentsV2/Schema/SchemaHelper';
import NetworkImage from 'components/NetworkImage';
import { PAGE_LIVE } from 'helpers/PageHelper';
import {
  clearVideo as clearGlobalVideo,
  setScreenInControlOfState as setGlobalPlayerScreenInControlOfState,
  setDisableRender as setGlobalVideoDisabled,
  setVideoPanel as setGlobalVideoPanel,
  saveLiveRestart,
  setStreamExit,
} from 'components/VideoPlayerGlobal/Actions';
import {
  getLocation,
  getPreviousPathname,
  helperGetHomeUrl,
  helperGetLiveUrl,
  helperGetStaticContentUrl,
} from 'helpers/RouteHelper';
import {
  canDisplayUpsell,
  getErrorComponent,
  isStaticRender,
  TAB_PRIMETIME,
  TAB_SCHEDULE,
} from 'helpers/ContentHelper';
import { toBoolean, noop } from 'helpers/GlobalHelper';
import { SUCCESS_COOKIE_NAME } from 'helpers/AuthHelper';
import { now, isSameSecond, isBefore } from 'helpers/DateTimeHelper';
import { PLAYER_CONTEXT_LIVE, PLAYER_REFERENCE_GLOBAL, playerRemove } from 'helpers/PlayerHelper';
import { primeTimeVideoProcessor, singleStationVideoProcessor } from 'helpers/VideoProcessorHelper';
import {
  Events,
  getSegmentLivePageName,
  getTealiumSourceCollectionGlobal,
  handleAnalytics,
  PageNames,
  setSegmentContextSourceLive,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { logEvent } from 'helpers/LogReportHelpers';
import UpdaterComponent from 'screens/Live/components/PrimeTimeUpdater';
import ScheduleGridComponent from 'screens/Live/components/ScheduleGrid';
import PrimeTimeGridComponent from 'screens/Live/components/PrimeTimeGrid';
import NationPrimeTimeGrid from 'screens/Live/components/NationPrimeTimeGrid';
import NationPrimeTimeGridLoader from 'screens/Live/components/NationPrimeTimeGridLoader';
import breadcrumbsTheme from 'screens/Live/styles/Breadcrumbs.module.scss';
import {
  displayPrimeTimeMessage,
  getPrimeTimeMessage,
  isVideoLive,
  checkSameDayOfYear,
  epgLinks,
  getLiveDateRange,
  getLiveVideo,
  getSingleStationSchedulePanels,
} from './LiveHelpers';
import {
  clearLive,
  fetchLiveAction,
  fetchLivePanel,
  fetchLivestream,
  fetchPrimeTime,
} from './LiveActions';
import Style from './Live.module.scss';

const LIVE_SCROLL_ELEMENT = 'LIVE_SCROLL_ELEMENT';
const getSelectedTab = props => {
  const slug = _.trim(_.get(props, 'location.pathname'));
  let selectedTab = epgLinks.defaultTab;
  if (slug && _.includes(slug, 'nav')) selectedTab = epgLinks.navLinkTab;
  if (slug && _.includes(slug, 'schedule')) selectedTab = epgLinks.scheduleLinkTab;

  return selectedTab;
};

class Live extends Component {
  constructor(props) {
    super(props);
    const selectedTab = getSelectedTab(props);
    const { globalVideo, defaultProgram, defaultChannel } = this.props;
    let selectedVideo = null;
    let selectedVideoData = null;
    if (globalVideo) {
      selectedVideoData = globalVideo;
      selectedVideo = _.get(globalVideo, 'livePlayerScreenUrl');
    }
    this.state = {
      selectedChannel: null,
      selectedDate: now(),
      selectedVideo,
      selectedVideoData,
      loadingGrid: false,
      selectedTab,
      panelTimeouts: {},
      firstChannelClick: false,
      liveVideoFetched: false,
      newRelicStart: false,
      selectedChannelCallSign: null,
      isNationDigitalChannel: nationDigitalChannelEnabled(),
      // trackedAnalyticsReferrer is used in trackPageReferrerAnalytics
      // eslint-disable-next-line react/no-unused-state
      trackedAnalyticsReferrer: false,
      defaultChannel,
      defaultProgram,
    };

    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.ignoreUnmountReferrerAnalytics = false;
  }

  componentDidMount() {
    const {
      globalVideo,
      preauthorizedResources,
      routeParams,
      setGlobalPlayerScreenInControlOfState,
      setLivePage,
      startedPlayback,
    } = this.props;
    const urlVideoId = _.get(routeParams, 'videoId');
    if (canDisplayUpsell(preauthorizedResources) && !urlVideoId) window.location = BaseUrl;
    const successCookie = getCookie({ name: SUCCESS_COOKIE_NAME });
    const selectedChannel = _.get(successCookie, 'selectedChannel');
    if (selectedChannel) this.onChannelSelect({ selectedChannel });
    if (setLivePage) setLivePage(true);
    this.setPageView();
    const source = PAGE_LIVE;
    setGlobalPlayerScreenInControlOfState(source);
    const playbackPersistedFromPreviousScreen = !!globalVideo && startedPlayback;
    logEvent('onLiveScreenStart');
    logEvent('onLiveScreenView');
    this.fetchLocalData({ preventGlobalPanelSet: playbackPersistedFromPreviousScreen });
    this.setState({ defaultChannel: null, newRelicStart: true });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { panels } = this.props;
    const { loadingGrid, selectedTab, selectedDate } = this.state;
    const { panels: nextPanels } = nextProps;
    const newState = {};

    if (loadingGrid === true) newState.loadingGrid = false;

    this.setSelectedTab(selectedTab, nextProps);

    if (checkSameDayOfYear(selectedDate, now()) && panels !== nextPanels) {
      newState.currentSchedule = nextPanels;
    }

    if (!_.isEmpty(newState)) this.setState(newState);
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { selectedChannel, defaultChannel } = this.state;
    const { params: prevParams } = this.props;
    const { defaultChannelVideo, panels: nextPanels, params: nextParams } = nextProps;
    const { selectedChannelCallSign } = nextState;
    const { callSign: prevCallSign } = prevParams;
    const { callSign: nextCallSign } = nextParams;

    const callSignChanged = prevCallSign !== nextCallSign && nextCallSign;

    if (callSignChanged && selectedChannelCallSign !== nextCallSign) {
      this.onChannelSelect({ callSign: nextCallSign });
    }

    this.setFirstChannel(defaultChannel, defaultChannelVideo, selectedChannel, nextPanels);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      accessToken,
      clearGlobalVideo,
      clearLive,
      coordinates,
      deviceId,
      fetchLivestream,
      panels,
      routeParams,
      savedVideo,
      video,
    } = this.props;
    const {
      accessToken: prevAccessToken,
      coordinates: prevCoordinates,
      panels: prevPanels,
      routeParams: prevRouteParams,
      savedVideo: prevSavedVideo,
      video: prevVideo,
    } = prevProps;
    const {
      selectedChannel,
      selectedChannelCallSign,
      liveVideoFetched,
      defaultChannel,
      defaultProgram,
      newRelicStart,
    } = this.state;
    const { selectedVideo: prevSelectedVideo } = prevState;

    if (newRelicStart) {
      logEvent('onLiveScreenFinished');
      this.setState({ newRelicStart: false });
    }
    const member = _.get(panels, 'member', null);
    const userLocationChanged = !_.isEqual(prevCoordinates, coordinates);
    const panelsChanged = !prevPanels && panels;
    const userSelectedChannel = member && !prevSelectedVideo && selectedChannel !== null;
    const accessTokenChanged = accessToken !== prevAccessToken;
    const savedVideoChanged = savedVideo !== prevSavedVideo;
    const videoIdChanged = video !== prevVideo;
    const urlVideoId = _.get(routeParams, 'videoId');
    const prevUrlVideoId = _.get(prevRouteParams, 'videoId');
    const urlVideoIdChanged = urlVideoId !== prevUrlVideoId;

    if (userSelectedChannel) {
      this.onChannelSelect({
        selectedChannel: selectedChannel || 0,
        channels: member,
      });
    }

    if (
      !EpgEnabled &&
      urlVideoId &&
      !savedVideo &&
      !prevSavedVideo &&
      !video &&
      !liveVideoFetched
    ) {
      fetchLivestream(accessToken, urlVideoId, deviceId);
      this.setState({ liveVideoFetched: true });
    }

    if (userLocationChanged || accessTokenChanged || savedVideoChanged || videoIdChanged) {
      this.fetchLocalData();
    }

    if (panelsChanged) this.setPanelTimeouts();

    if (videoIdChanged && selectedChannel !== null && panels && selectedChannelCallSign) {
      const newCallSign = _.get(panels, `member.${selectedChannel}.callSign`);
      if (newCallSign !== selectedChannelCallSign) {
        this.onChannelSelect({ callSign: newCallSign });
      }
    }
    if (defaultProgram && defaultChannel && !selectedChannel) {
      this.onChannelSelect({ selectedChannel: defaultChannel, programId: defaultProgram });
    }

    if (urlVideoIdChanged) {
      clearLive();
      clearGlobalVideo();
      this.fetchLocalData();
    }
  }

  componentWillUnmount() {
    const { clearGlobalVideo, clearLive, setGlobalVideoDisabled, setLivePage } = this.props;
    const source = PAGE_LIVE;
    setGlobalVideoDisabled({ value: true, source });
    clearGlobalVideo({ source });
    setLivePage(false);
    clearLive();
  }

  onChannelSelect = (opts = {}) => {
    const {
      selectedChannel,
      callSign,
      channels,
      id: panelId,
      programId,
      clearQuery = false,
      overrideDigitalChannel,
    } = opts;
    let isOverFlow = false;
    const { location, setGlobalVideoPanel } = this.props;
    const {
      selectedVideo: prevSelectedVideo,
      selectedVideoData: prevSelectedVideoData,
      selectedChannel: prevSelectedChannel,
      firstChannelClick,
      defaultProgram,
      defaultChannel,
    } = this.state;
    const urlParams = _.get(location, `query`);
    const epgListingId = clearQuery ? '' : _.get(urlParams, 'id');
    const channelList = !overrideDigitalChannel
      ? channels || _.get(this.props, 'panels.member')
      : _.get(this.props, 'panels.member.0.items.member');
    let channelIndex = selectedChannel;
    let selectedPanel = null;
    if (!channelIndex && callSign) {
      channelIndex = _.toInteger(
        _.findKey(channelList, channel => _.toUpper(channel.callSign) === _.toUpper(callSign)),
      );
      if (epgListingId) {
        selectedPanel = _.get(channelList, `${channelIndex}`, []);
        const panelItems = _.get(selectedPanel, 'items.member');
        const livePanelItems = _.filter(panelItems, item => isVideoLive(item));
        const epgItemIndex = _.toInteger(_.findKey(livePanelItems, { id: epgListingId }));
        channelIndex = epgItemIndex !== 0 ? `${channelIndex}-${epgItemIndex}` : channelIndex;
      }
    }
    if (channelIndex && _.includes(channelIndex, '-overFlow')) {
      isOverFlow = true;
      channelIndex = parseInt(_.replace(channelIndex, '-overFlow', ''), 10);
    }
    if (!selectedPanel) {
      selectedPanel = _.get(channelList, `${channelIndex}`, []);
    }
    if (panelId) {
      selectedPanel = channelList.find(panel => panel.id === panelId);
    }
    if (defaultChannel && channelList) {
      selectedPanel = channelList.find(panel => {
        const callSign = _.get(panel, 'callSign');
        return callSign && callSign.toLowerCase() === defaultChannel.toLowerCase();
      });
    }
    let selectedVideoData = {};
    // Revisit
    const newProgram = programId || defaultProgram;
    if (newProgram) {
      const programs = _.get(selectedPanel, 'items.member', []);
      selectedVideoData = programs.find(program => program.id === newProgram);
    } else {
      selectedVideoData = getLiveVideo({ panel: selectedPanel, isOverFlow, epgListingId });
      if (!selectedVideoData && overrideDigitalChannel) {
        selectedVideoData = selectedPanel;
      }
    }
    const livePlayerScreenUrl = _.get(selectedVideoData, 'livePlayerScreenUrl', null);
    const playerScreenUrlChange =
      _.get(selectedVideoData, 'playerScreenUrl') !==
      _.get(prevSelectedVideoData, 'playerScreenUrl');
    const channelChange = selectedChannel !== prevSelectedChannel;

    if (channelChange) {
      if (!firstChannelClick) {
        this.setState({ firstChannelClick: true });
      } else {
        setSegmentContextSourceLive(false);
      }
      animateScroll.scrollTo(0, { duration: 500, smooth: true });
    }

    if (prevSelectedVideo === livePlayerScreenUrl && !playerScreenUrlChange && !channelChange)
      return;

    if (selectedVideoData) {
      setGlobalVideoPanel({ video: selectedVideoData, source: PAGE_LIVE });
    }

    const selectedChannelCallSign = _.get(selectedPanel, 'callSign');
    this.setState({
      selectedChannel: channelIndex,
      selectedChannelCallSign,
      selectedVideo: livePlayerScreenUrl,
      selectedVideoData,
    });
  };

  getChannelContent() {
    const { panels } = this.props;
    const { selectedChannel } = this.state;
    return _.get(panels, `member.${selectedChannel || 0}`);
  }

  getNetwork() {
    return _.get(this.getChannelContent(), 'items.member.0.network');
  }

  getPrimeTimeMessage() {
    const { panels } = this.props;
    const { selectedChannel, selectedDate } = this.state;
    const { seriesDetail_tuneinTextSeparator: textSeparator } = window.Language;
    const message = getPrimeTimeMessage({
      panels,
      selectedChannel,
      selectedDate,
    });

    const network = this.getNetwork();

    return (
      <div className={Style.bannerCopy}>
        <span>
          {message} {textSeparator}
        </span>
        <NetworkImage network={network} title={message} />
      </div>
    );
  }

  setFirstChannel(defaultChannel, defaultChannelVideo, selectedChannel, nextPanels) {
    if (selectedChannel === null && !isStaticRender() && nextPanels) {
      const urlCallSign = _.get(this.props, 'params.callSign');
      let newChannel = 0;
      const channels = _.get(nextPanels, 'member', null);
      const getChannelIdxFromVideoId = videoId =>
        _.findIndex(channels, channel => {
          const currentVideoIndex = _.findIndex(channel.items.member, video => isVideoLive(video));
          const currentVideo = _.get(channel, `items.member.${currentVideoIndex}`, null);
          const currentVideoId = _.get(currentVideo, 'id', null);
          return currentVideoId === videoId;
        });
      const { globalVideo, startedPlayback } = this.props;
      if (globalVideo && startedPlayback) {
        const globalVideoId = _.get(globalVideo, 'id', null);
        newChannel = getChannelIdxFromVideoId(globalVideoId);
        this.setState({ selectedChannel: newChannel });
      } else if (urlCallSign) {
        this.onChannelSelect({ callSign: urlCallSign, channels });
      } else {
        if (defaultChannel) {
          newChannel = getChannelIdxFromVideoId(defaultChannelVideo);
          // check for channel if defaultChannelVideo is not live
          if (newChannel === -1 && defaultChannelVideo) {
            newChannel = _.findIndex(channels, channel => {
              let videoFound = false;
              let currentVideoId;
              _.forEach(channel.items.member, video => {
                currentVideoId = _.get(video, 'id', null);
                if (currentVideoId === defaultChannelVideo) videoFound = true;
              });
              return videoFound;
            });
          }
        }
        if (newChannel >= 0) {
          this.onChannelSelect({ selectedChannel: newChannel, channels });
        }
      }
    }
  }

  setPageView() {
    const { pageViewEvent, getUseUtagGlobal } = this.props;
    const sourceCollection = getTealiumSourceCollectionGlobal();
    const collection = sourceCollection ? { ...sourceCollection } : null;
    const useUtagGlobal = getUseUtagGlobal();

    if (!collection) {
      pageViewEvent({ pageName: PageNames.LIVE, useUtagGlobal });

      const callSign = _.get(window, 'utag_data.call_sign', null);
      handleAnalytics({
        event: Events.TOP_LEVEL_SECTION_LANDING,
        payload: {
          pageName: callSign ? `live:landing:${callSign}` : `live:landing`,
          callSign,
        },
      });
    }

    pageViewEvent({
      pageName: getSegmentLivePageName({
        location: getLocation(window.referrer),
        previousPath: getPreviousPathname(),
      }),
      useUtagGlobal,
    });
  }

  setPanelTimeouts() {
    const { clearTimeout, panels, setTimeout } = this.props;
    if (!panels) return;
    const { panelTimeouts: prevPanelTimeouts, selectedDate } = this.state;
    const currentDate = now();
    const sameDay = checkSameDayOfYear(currentDate, selectedDate);
    let duration = null;
    let timeoutId = null;
    const newTimeouts = {};
    _.forEach(panels.member, panel => {
      duration = panel.validFor;
      timeoutId = `panel-${panel.id}`;
      if (prevPanelTimeouts[timeoutId]) clearTimeout(prevPanelTimeouts[timeoutId]);
      if (sameDay) {
        newTimeouts[timeoutId] = setTimeout(() => {
          this.fetchPanelData(panel);
        }, duration);
      }
    });
    this.setState({ panelTimeouts: newTimeouts });
  }

  setSelectedDate = (newSelectedDate, resetTimer = true) => {
    const { selectedDate: oldSelectedDate } = this.state;
    const oldDate = oldSelectedDate || now();
    const newDate = newSelectedDate || now();
    const currentDate = now();
    if (resetTimer) this.resetStillWatchingTimeout();
    if (!isSameSecond(oldDate, newDate)) {
      const selectedDate = isBefore(newDate, currentDate) ? currentDate : newDate;
      this.setState({ selectedDate });
    }
  };

  setSelectedTab(selectedTab, nextProps) {
    let newSelectedTab = selectedTab;

    const slug = _.trim(_.get(this.props, 'location.pathname'));
    const nextSlug = _.trim(_.get(nextProps, 'location.pathname'));

    const currentVideoHasNav = slug && _.includes(slug, 'nav');
    const nextVideoHasNav = nextSlug && _.includes(nextSlug, 'nav');
    if (nextVideoHasNav && currentVideoHasNav !== nextVideoHasNav) {
      newSelectedTab = epgLinks.navLinkTab;
    }

    const currentVideoHasSchedule = slug && _.includes(slug, 'schedule');
    const nextVideoHasSchedule = nextSlug && _.includes(nextSlug, 'schedule');
    if (nextVideoHasSchedule && currentVideoHasSchedule !== nextVideoHasSchedule) {
      newSelectedTab = epgLinks.scheduleLinkTab;
    }

    if (selectedTab !== newSelectedTab) this.setState({ selectedTab: newSelectedTab });
  }

  handleStreamExit = () => {
    const previousPath = getPreviousPathname();
    const wasLive = previousPath.match(/^\/(live)(\/)?(.*)$/);
    const homePath = helperGetHomeUrl();
    const nextPath = previousPath || homePath;

    if ((previousPath && !wasLive) || !previousPath) {
      browserHistory.push(nextPath);
    }
    return this.renderStreamExit();
  };

  resetStillWatchingTimeout = () => {
    const { setGlobalShouldResetStillWatching } = this.props;
    setGlobalShouldResetStillWatching(true);
  };

  fetchLocalData(options = {}) {
    const { panelUrl, preventGlobalPanelSet } = options;
    const {
      coordinates,
      accessToken,
      deviceId,
      fetchLiveAction,
      fetchLivePanel,
      routeParams,
      savedVideo,
      setGlobalVideoPanel,
      video,
    } = this.props;
    const { selectedDate, isNationDigitalChannel } = this.state;
    if (isStaticRender()) return;
    const urlVideoId = _.get(routeParams, 'videoId');
    if (!EpgEnabled && urlVideoId) {
      const selectedVideo =
        _.get(savedVideo, 'livePlayerScreenUrl') || _.get(video, 'livePlayerScreenUrl', null);
      const currentVideo = savedVideo || video;
      if (!preventGlobalPanelSet && currentVideo) {
        setGlobalVideoPanel({ video: currentVideo, source: PAGE_LIVE });
      }

      this.setState({
        selectedVideo,
        selectedVideoData: savedVideo || video,
      });
      return;
    }
    const dateRange = getLiveDateRange(selectedDate);
    if (panelUrl) {
      fetchLivePanel({ accessToken, panelUrl, dateRange, coordinates, deviceId });
    } else {
      this.setState({ loadingGrid: true });
      fetchLiveAction({ accessToken, dateRange, coordinates, deviceId, isNationDigitalChannel });
    }
  }

  fetchPanelData(panel) {
    const { clearTimeout, setTimeout } = this.props;
    const url = panel['@id'];
    this.fetchLocalData({ panelUrl: url });
    const { id, validFor } = panel;
    const timeoutId = `panel-${id}`;
    const { panelTimeouts: prevPanelTimeouts } = this.state;
    const newTimeout = {};
    if (prevPanelTimeouts[timeoutId]) clearTimeout(prevPanelTimeouts[timeoutId]);
    newTimeout[timeoutId] = setTimeout(() => {
      this.fetchPanelData(panel);
    }, validFor);
    const panelTimeouts = _.merge(prevPanelTimeouts, newTimeout);
    this.setState({ panelTimeouts });
  }

  renderBanner() {
    const primeTimeMessage = this.getPrimeTimeMessage();
    const backgroundUrl = helperGetStaticContentUrl('images', 'Fallback-FOX-bg.jpg');
    const backgroundImage = `url(${backgroundUrl})`;

    return (
      <div
        className={`${classNames(Style.container, Style.bannerContainer)}`}
        data-testid="ft-mobile-banner"
        style={{ backgroundImage }}
      >
        {primeTimeMessage}
      </div>
    );
  }

  renderLiveTV() {
    const {
      panels,
      account,
      preauthorizedResources,
      isAuthenticated,
      breakpoint,
      saveLiveRestart,
      setOverlay,
      overlay,
      favoritesManager,
      location,
    } = this.props;
    const {
      selectedVideoData,
      selectedChannel,
      selectedDate,
      loadingGrid,
      defaultProgram,
    } = this.state;

    return (
      <ScheduleGridComponent
        favoritesManager={favoritesManager}
        panels={panels}
        onChannelSelect={this.onChannelSelect}
        selectedChannel={selectedChannel}
        account={account}
        selectedDate={selectedDate}
        setSelectedDate={this.setSelectedDate}
        resetStillWatchingTimeout={this.resetStillWatchingTimeout}
        preauthorizedResources={preauthorizedResources}
        isAuthenticated={isAuthenticated}
        breakpoint={breakpoint}
        saveLiveRestart={saveLiveRestart}
        loadingGrid={loadingGrid}
        isStatic={isStaticRender()}
        setOverlay={setOverlay}
        overlay={overlay}
        selectedVideoData={selectedVideoData}
        location={location}
        defaultProgram={defaultProgram}
      />
    );
  }

  renderPlayerOrBanner() {
    const { globalPlayerDisabled, setGlobalVideoDisabled, streamExit } = this.props;
    const { selectedVideo } = this.state;

    const network = this.getNetwork();
    const shouldDisplayBanner = !selectedVideo && displayPrimeTimeMessage({ network });

    let output;
    const component = () => {
      const source = PAGE_LIVE;
      if (isStaticRender()) {
        output = <div className={Style.playerSpacer} />;
      } else if (shouldDisplayBanner) {
        output = this.renderBanner();
        if (!globalPlayerDisabled) setGlobalVideoDisabled({ value: true, source });
      } else {
        output = null;
        if (globalPlayerDisabled) {
          setGlobalVideoDisabled({
            context: PLAYER_CONTEXT_LIVE,
            source,
            value: false,
          });
        }
      }
      if (streamExit) {
        output = this.handleStreamExit();
      }
      return output;
    };

    return <UpdaterComponent>{component()}</UpdaterComponent>;
  }

  renderPrimeTimeSchedule() {
    const {
      primeTimePanels,
      primeTimePanelCount,
      account,
      preauthorizedResources,
      isAuthenticated,
      isNavScheduleRendered,
      breakpoint,
      coordinates,
      saveLiveRestart,
      setOverlay,
      overlay,
      favoritesManager,
    } = this.props;
    const { selectedChannel, selectedDate, loadingGrid } = this.state;

    const primeTimeGridProps = {
      account,
      breakpoint,
      coordinates,
      isAuthenticated,
      isNavScheduleRendered,
      loadingGrid,
      preauthorizedResources,
      primeTimePanelCount,
      primeTimePanels,
      processor: primeTimeVideoProcessor,
      saveLiveRestart,
      selectedChannel,
      selectedDate,
      onChannelSelect: this.onChannelSelect,
      resetStillWatchingTimeout: this.resetStillWatchingTimeout,
      setSelectedDate: this.setSelectedDate,
      setOverlay,
      overlay,
      favoritesManager,
    };

    return <PrimeTimeGridComponent {...primeTimeGridProps} />;
  }

  renderSingleStationSchedule() {
    const {
      account,
      breakpoint,
      isAuthenticated,
      overlay,
      preauthorizedResources,
      primeTimePanelCount,
      panels,
      routeParams,
      setOverlay,
      globalVideo,
    } = this.props;
    const { loadingGrid, selectedChannel, selectedDate, isNationDigitalChannel } = this.state;
    const urlVideoId = _.get(routeParams, 'videoId');
    if (urlVideoId) return null;

    const primeTimePanels = getSingleStationSchedulePanels(
      panels,
      isFNCv2Enabled(),
      isNationDigitalChannel,
    );
    const upcomingVideos = _.get(primeTimePanels, 'member.0.items.member', []);
    if (_.isEmpty(upcomingVideos) && !globalVideo) {
      if (isNationDigitalChannel)
        return (
          <div className={Style.loaderContainer}>
            <Loader className={Style.loader} />
          </div>
        );
      return isFNCv2Enabled() ? <NationPrimeTimeGridLoader /> : null;
    }
    const currentLiveVideo = isNationDigitalChannel
      ? globalVideo || getLiveVideo({ panel: panels.member[0] })
      : getLiveVideo({ panel: panels.member[0] });
    const primeTimeGridProps = {
      account,
      breakpoint,
      filterGridByDay: true,
      initialDisplayCount: 5,
      isAuthenticated,
      loadingGrid,
      preauthorizedResources,
      primeTimePanelCount,
      primeTimePanels,
      processor: singleStationVideoProcessor,
      scrollToDateOnMount: false,
      selectedChannel,
      selectedDate,
      onChannelSelect: this.onChannelSelect,
      resetStillWatchingTimeout: this.resetStillWatchingTimeout,
      setSelectedDate: this.setSelectedDate,
      setOverlay,
      overlay,
    };
    const nationPrimeTimeGridProps = {
      ...primeTimeGridProps,
      currentLiveVideo,
    };
    return isFNCv2Enabled() ? (
      <NationPrimeTimeGrid {...nationPrimeTimeGridProps} />
    ) : (
      <PrimeTimeGridComponent {...primeTimeGridProps} />
    );
  }

  renderShowSchedules() {
    if (!EpgEnabled) return null;
    const { selectedTab } = this.state;
    return (
      <Element name={LIVE_SCROLL_ELEMENT} data-testid="live-epg">
        {this.renderTabs()}
        {selectedTab === TAB_PRIMETIME && this.renderPrimeTimeSchedule()}
        {selectedTab === TAB_SCHEDULE && this.renderLiveTV()}
      </Element>
    );
  }

  renderStreamExit = () => {
    playerRemove(PLAYER_REFERENCE_GLOBAL);
    const backgroundUrl = helperGetStaticContentUrl('images', 'Fallback-FOX-bg.jpg');
    const backgroundImage = `url(${backgroundUrl})`;

    const title = _.get(window, 'Language.streamExit_header', 'Your program has ended');
    const subtitle = _.get(
      window,
      'Language.streamExit_message',
      'Check out another live stream below.',
    );

    return (
      <div
        className={`${classNames(Style.container, Style.exitContainer)}`}
        style={{ backgroundImage }}
      >
        <div className={Style.exitCopy}>
          <span className={Style.exitHeader}>{title}</span>
          <span>{subtitle}</span>
        </div>
      </div>
    );
  };

  renderTabs() {
    const { globalNavPrimetimeTickerEnabled } = window.ExternalConfig;
    const primetimeScheduleEnabled = toBoolean(globalNavPrimetimeTickerEnabled);
    if (!primetimeScheduleEnabled) return null;

    const { panels } = this.props;
    const { selectedTab } = this.state;
    const {
      epg_primetimeButton: primeTimeText,
      epg_scheduleButton: scheduleText,
    } = window.Language;

    if (!panels) return null;

    const tabOrder = _.get(epgLinks, 'tabOrder');

    const tabTitles = {};
    tabTitles[TAB_PRIMETIME] = primeTimeText;
    tabTitles[TAB_SCHEDULE] = scheduleText;

    const getLiveTabSlug = tab => {
      const { navLinkTab } = epgLinks;
      if (tab === navLinkTab) return 'nav';
      return 'schedule';
    };

    const tabs = tabOrder.map(tab => (
      <Link
        className={classNames(Style.tab, selectedTab === tab ? Style.active : null)}
        to={`${helperGetLiveUrl()}${getLiveTabSlug(tab)}/`}
        key={`live-tab-${getLiveTabSlug(tab)}`}
      >
        {tabTitles[tab]}
      </Link>
    ));

    return <div className={Style.tabButtons}>{tabs}</div>;
  }

  renderStrikeBanner = () => {
    if (!strikeBannerEnabled()) return null;
    const bannerProps = {
      index: 1,
      pageType: STRIKE_PAGE_TYPE_SCHEDULE,
    };
    return <StrikeBanner {...bannerProps} />;
  };

  render() {
    const {
      coordinates,
      errors,
      globalVideo,
      panels,
      routeParams,
      savedVideo,
      seo: dppSEO,
      setLoading,
      video,
    } = this.props;
    const { selectedTab, isNationDigitalChannel } = this.state;
    let seo = dppSEO;
    if (errors && !_.isArray(errors)) return getErrorComponent(errors);
    const hasPanels = !!(panels && panels.member && panels.member.length > 0);
    const urlVideoId = _.get(routeParams, 'videoId');
    const showLoader = (coordinates && EpgEnabled) || !urlVideoId;
    if (!seo) {
      seo = {
        canonicalUrl: `${BaseUrl}/live/${urlVideoId}`,
        title: ` ${video?.name} Watch Live - Fox Nation
        `,
      };
    }
    const tags = setHelmetTags(seo);
    if (showLoader && !hasPanels && !globalVideo) {
      return <Loader setLoading={setLoading} center />;
    }
    const epgContainerClasses = [Style.epgWrap];
    epgContainerClasses.push(Style.epgWrapNation);
    const breadcrumbsData = breadcrumbsLiveParser(selectedTab, savedVideo, true);
    const breadcrumbs = <BreadcrumbsComponent data={breadcrumbsData} theme={breadcrumbsTheme} />;

    if (!isNationDigitalChannel) {
      return (
        <section className={classNames(epgContainerClasses)}>
          <StickyContainer>
            <div className={Style.epgContainer}>
              {tags}
              {this.renderPlayerOrBanner()}
              {this.renderShowSchedules()}
              {this.renderSingleStationSchedule()}
            </div>
          </StickyContainer>
          {this.renderStrikeBanner()}
          {hasPanels || !EpgEnabled ? breadcrumbs : null}
        </section>
      );
    }

    return (
      <div className={Style.digitalChannelContainer}>
        <Schema schemas={[{ item: globalVideo, type: SCHEMA_TYPES.VIDEO_OBJECT }]} />
        {tags}
        {this.renderPlayerOrBanner()}
        {this.renderShowSchedules()}
        {this.renderSingleStationSchedule()}
        {hasPanels || !EpgEnabled ? breadcrumbs : null}
      </div>
    );
  }
}

Live.defaultProps = {
  accessToken: null,
  account: null,
  adblock: false,
  anonymousId: null,
  campaignOverrides: {},
  clearGlobalVideo: noop,
  clearInterval: noop,
  clearTimeout: noop,
  coordinates: null,
  defaultChannel: null,
  defaultProgram: null,
  deviceId: null,
  errors: null,
  favoritesManager: {},
  fetchLivestream: noop,
  globalPlayerDisabled: true,
  globalVideo: null,
  isAuthenticated: false,
  isHeader: false,
  isPlayerLoaded: false,
  livePanel: null,
  location: {},
  mvpd: null,
  overlay: null,
  panels: null,
  params: {},
  preauthorizedResources: [],
  primeTimePanelCount: null,
  primeTimePanels: null,
  profileId: null,
  provider: {},
  routeParams: {},
  savedVideo: null,
  seo: null,
  setCoordinates: noop,
  setGlobalShouldResetStillWatching: noop,
  setGlobalVideoDisabled: noop,
  setGlobalVideoPanel: noop,
  setInterval: noop,
  setIsPlayerLoaded: noop,
  setLivePage: noop,
  setLoading: null,
  setMVPDToAppState: noop,
  setPreauthorizedResources: null,
  setProvider: noop,
  setTimeout: noop,
  startedPlayback: false,
  streamExit: false,
  video: null,
};

Live.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({}),
  adblock: PropTypes.bool,
  anonymousId: PropTypes.string,
  anonymousLogin: PropTypes.func.isRequired,
  breakpoint: PropTypes.string.isRequired,
  campaignOverrides: PropTypes.shape({}),
  clearGlobalVideo: PropTypes.func,
  clearInterval: PropTypes.func,
  clearLive: PropTypes.func.isRequired,
  clearTimeout: PropTypes.func,
  coordinates: PropTypes.shape({}),
  defaultChannel: PropTypes.string,
  defaultProgram: PropTypes.string,
  deviceId: PropTypes.string,
  errors: PropTypes.number,
  favoritesManager: PropTypes.shape({
    deleteFavorites: PropTypes.func.isRequired,
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
  }),
  fetchLiveAction: PropTypes.func.isRequired,
  fetchLivePanel: PropTypes.func.isRequired,
  fetchLivestream: PropTypes.func,
  fetchPrimeTime: PropTypes.func.isRequired,
  getUseUtagGlobal: PropTypes.func.isRequired,
  globalPlayerDisabled: PropTypes.bool,
  globalVideo: PropTypes.shape({}),
  isAuthenticated: PropTypes.bool,
  isHeader: PropTypes.bool,
  isNavScheduleRendered: PropTypes.bool.isRequired,
  isPlayerLoaded: PropTypes.bool,
  livePanel: PropTypes.shape({}),
  location: PropTypes.shape({}),
  mvpd: PropTypes.shape({}),
  overlay: PropTypes.string,
  pageViewEvent: PropTypes.func.isRequired,
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  params: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  primeTimePanelCount: PropTypes.number,
  primeTimePanels: PropTypes.shape({}),
  profileId: PropTypes.string,
  provider: PropTypes.shape({}),
  renderAuthContainer: PropTypes.func.isRequired,
  routeParams: PropTypes.shape({}),
  saveLiveRestart: PropTypes.func.isRequired,
  savedVideo: PropTypes.shape({}),
  seo: PropTypes.shape({}),
  setAuthorizationToken: PropTypes.func.isRequired,
  setCoordinates: PropTypes.func,
  setGlobalPlayerScreenInControlOfState: PropTypes.func.isRequired,
  setGlobalShouldResetStillWatching: PropTypes.func,
  setGlobalVideoDisabled: PropTypes.func,
  setGlobalVideoPanel: PropTypes.func,
  setInterval: PropTypes.func,
  setIsAuthenticated: PropTypes.func.isRequired,
  setIsPlayerLoaded: PropTypes.func,
  setLivePage: PropTypes.func,
  setLoading: PropTypes.func,
  setMVPDToAppState: PropTypes.func,
  setOverlay: PropTypes.func.isRequired,
  setPreauthorizedResources: PropTypes.func,
  setProvider: PropTypes.func,
  setTimeout: PropTypes.func,
  startedPlayback: PropTypes.bool,
  streamExit: PropTypes.bool,
  video: PropTypes.shape({}),
};

const mapStateToProps = ({
  live: {
    currentTime,
    defaultChannel,
    defaultChannelVideo,
    defaultProgram,
    errors,
    panel,
    panels,
    primeTimePanels,
    savedVideo,
    seo,
    video,
  },
  globalVideo: {
    disableRender: globalPlayerDisabled,
    startedPlayback,
    video: globalVideo,
    streamExit,
  },
}) => {
  const primeTimePanelCount = primeTimePanels && primeTimePanels.length;

  return {
    currentTime,
    defaultChannel,
    defaultChannelVideo,
    defaultProgram,
    errors,
    globalPlayerDisabled,
    globalVideo,
    livePanel: panel,
    panels,
    primeTimePanelCount,
    primeTimePanels,
    savedVideo,
    seo,
    startedPlayback,
    video,
    streamExit,
  };
};

const TimeoutLive = ReactTimeout(
  connect(mapStateToProps, {
    clearGlobalVideo,
    clearLive,
    fetchLiveAction,
    fetchLivePanel,
    fetchLivestream,
    fetchPrimeTime,
    saveLiveRestart,
    setGlobalPlayerScreenInControlOfState,
    setGlobalVideoDisabled,
    setGlobalVideoPanel,
    setStreamExit,
  })(Live),
);

export default TimeoutLive;
